import { render } from "./VsolEponTable.vue?vue&type=template&id=0f3681a3&scoped=true"
import script from "./VsolEponTable.vue?vue&type=script&lang=js"
export * from "./VsolEponTable.vue?vue&type=script&lang=js"

import "./VsolEponTable.vue?vue&type=style&index=0&id=0f3681a3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3681a3"]])

export default __exports__